import React, { useEffect, useState } from 'react';
import { globals } from '../../misc/globals';
import { getOptionBorder, mapDivEnterToClick } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';
import ContnueButton from './ContinueButton';
import './NurseStationComputerSingleQuestionUI.css'
import { DialogueUIOptionConfig } from './YouRespondUI';

var selectedIndx = -1;
const NurseStationComputerSingleQuestionUI = (props: UIProperties<NurseStationComputerSingleQustionUIConfig>) => {
	const [selectedChoice, setSelectedChoice] = useState(null);
	const getLetter=(optionIndx: number) => {
		var optionLetters = [
			'A',
			'B',
			'C',
			'D'
		];

		return optionLetters[optionIndx];
	}

	useEffect(() => {
		if(props.parameters.refresh) {
			props.parameters.refresh = false;
			setSelectedChoice(null);
		}
	});
	const getOptionTopPosition=(optionIndx: number) => {
		var indexInReferenceToHiddenObjects = 0;
		
		for(var indx = 0; indx < props.parameters.options.length; indx++) {
			if(optionIndx === indx) {
				break;
			}
			//if the item is hidden, do not account that when positioning this option
			if(!props.parameters.options[indx].hide) {
				indexInReferenceToHiddenObjects++;
			}
		}
		
		switch(indexInReferenceToHiddenObjects) {
			case 0:
				return 119;
			case 1:
				return 231;
			case 2:
				return 341;
			case 3: 
				return 454;
		}
	}
	return (
		<div className="in-game-ui-container nurse-station-single-question-bg-top">
			<div tabIndex={0} aria-label={'Question'} id='nurse-station-computer-single-question-first' style={{
					position: 'absolute',
					width: '1340px',
					left: '50%',
					transform: 'translate(-50%, 0)',
					bottom: '100px'
				}} >
				<img src="./assets/images/general/components/nurse-station-computer/nurse-station-background.png"/>
			</div>
			<div className="nurse-station-single-question" style={{
				position: 'relative',
				width: '970px',
				height: '630px',
				pointerEvents: 'all',
				left: '50%',
				transform: 'translate(-50%, 0)',
				top: '300px'
			}}>
				{selectedChoice ? (null) : <img style={{
					position: 'relative',
					top: '50px'
				}} src={"./assets/images/general/components/nurse-station-computer-single/nurse-station-computer-single-" + props.parameters.options.filter(o => !o.hide).length + "-options-bg.png"} />}
				<p className="title-font" style={{
					position: 'absolute',
					margin: '0',
					top: '14px',
					left: '61px'
				}} tabIndex={0}>{props.parameters.title}</p>

				{selectedChoice ? (
					<div style={{
						position: 'absolute',
						top: '60px',
						height: '500px'
					}}>
						<p className="title-font" style={{
							color: selectedChoice.isCorrect ? 'rgba(50,255,49)' : 'rgba(255,128,0)',
							textAlign: 'center',
							fontSize: '50pt',
							marginTop: '50px',
							marginBottom: '40px'
						}} tabIndex={0}>{selectedChoice.isCorrect ? 'CORRECT' : 'SORRY, TRY AGAIN'}</p>
						<p className="regular-description-font" style={{
							fontSize: '20pt'
						}} tabIndex={0}>{selectedChoice.feedback}</p>
						<ContnueButton parameters= {{
							top: '521px',
							left: '391px',
							width: '190px',
							id:'nurse-station-computer-single-question-last',
							onClicked: () => {
								if(selectedChoice.isCorrect) {
									props.parameters.selectedOption = selectedIndx;
									props.parameters.onClosed(props.parameters);
								} else {
									selectedChoice.hide = true;
									setSelectedChoice(null);
								}
							}
						}}/>
					</div>
				) : (
					<div>
						{props.parameters.options.map((o: DialogueUIOptionConfig, i: any) => {
							return (o.hide ? (null) :
								<div key={i} className="pointer" tabIndex={0} aria-label={getLetter(i) + '. ' + o.text} 
								onKeyUp={mapDivEnterToClick}
								onClick={ () => {
									selectedIndx = i;

									var clickAudio = document.getElementById('button-click');
									
									if(!globals.isMuted) {
										(clickAudio as any).play();
									}
									
									var audio = document.getElementById(o.isCorrect ? 'correct-audio' : 'wrong-audio');
									
									if(!globals.isMuted) {
										(audio as any).play()
									}
									
									if(props.parameters.onChoiceSelected) {
										props.parameters.onChoiceSelected(o,selectedIndx);

									}

									if(props.parameters.isSummative) {
										props.parameters.onClosed(props.parameters);
										return;
									}									
									setSelectedChoice(o);
								}} style={{
									position: 'absolute',
									left: '19px',
									top: getOptionTopPosition(i) + 'px',
									height: '91px',
									width: '940px',
									border: globals.showDebugForComponents && globals.showDebugAnswerTypes ? getOptionBorder(o.scoreType) : ''
								}}>
									<p className="big-description-font" style={{
										position: 'relative',
										margin: '0px',
										left: '31px',
										top: '44px',
										display: 'inline'
									}}>{getLetter(i) + '.'}</p>

									<p className="big-description-font" style={{
										maxWidth: '810px',
										overflow: 'hidden',
										position: 'absolute',
										top: '50%',
										left: '82px',
										margin: '0',
										padding: '0',
										transform: 'translate(0, -50%)',
										maxHeight: '80px'
									}}>{o.text}</p>
								</div>
							);
						})}
					</div>
				)}
			</div>
		</div>
	);
};

export interface NurseStationComputerSingleQustionUIConfig extends BaseConfig {
	title: string;
	options: DialogueUIOptionConfig[];
	selectedOption: number;
	aarScenarioID?: number;
	aarSectionID?: number;
	refresh?: boolean;
	isSummative: boolean;
	onChoiceSelected?: (selectedChoice: DialogueUIOptionConfig, selectedIndx: number) => void;
	onClosed: (config: NurseStationComputerSingleQustionUIConfig) => void;
}

export default NurseStationComputerSingleQuestionUI;